<template>
    <div>
        <div class="container">
            <div class="top-header">
                <div class="row">
                    <div class="col-md-2">
                        <img src="../assets/superkids/superkid-logo.svg" alt="logo">
                    </div>
                    <div class="col-md-8">
                        <h3>Volunteer Application Form</h3>
                        <p>Please complete the form below to apply as a SuperKids community volunteer.</p>
                    </div>
                </div>
            </div>

            <div class="registration-holder">
                <div class="">
                    <div class="row">
                        <div class="col-md-4 d-none d-lg-block">
                            <div id="" class="wizard">

                                <!-- Sidebar -->
                                <div class="steps">
                                    <div
                                        v-for="(step, index) in steps"
                                        :key="index"
                                        class="step"
                                        :class="{
                                        completed: index < currentStep,
                                        active: index === currentStep,
                                        disabled: index > currentStep
                                        }"
                                    >
                                        <div class="indicator">
                                        <span v-if="index < currentStep || aggreement  == 'yes'">✔</span>
                                        <span v-else>{{ index + 1 }}</span>
                                        </div>

                                        <div class="label">
                                        {{ step }}
                                        </div>

                                        <!-- Vertical line -->
                                        <div
                                        v-if="index !== steps.length - 1"
                                        class="line"
                                        ></div>
                                    </div>
                                </div>

                                <!-- Form Content -->
                                <!-- <div class="content">
                                    <h2>{{ steps[currentStep] }}</h2>

                                    <div v-if="currentStep === 0">Step 1 content</div>
                                    <div v-if="currentStep === 1">Step 2 content</div>
                                    <div v-if="currentStep === 2">Step 3 content</div>
                                    <div v-if="currentStep === 3">Step 4 content</div>
                                    <div v-if="currentStep === 4">Step 5 content</div>
                                    <div v-if="currentStep === 5">Step 6 content</div>

                                    <div class="actions">
                                        <button @click="prev" :disabled="currentStep === 0">
                                        Back
                                        </button>
                                        <button @click="next" :disabled="currentStep === steps.length - 1">
                                        Next
                                        </button>
                                    </div>
                                </div> -->
                            </div>
                        </div>
                        <div class="col-md-8">
                            <div class="">
                                <div>
                                    <h3>{{ steps[currentStep] }}</h3>
                                    <p>{{ substeps[currentSubStep] }}</p>
                                </div>

                                <div class="form" v-if="currentStep === 0">
                                    <div class="row">
                                        <div class="form-group col-md-6">
                                            <label for="fullname">Full Name</label>
                                            <input v-model="volunteerForm.fullname" type="text" class="form-control inputtext" id="fullname" placeholder="Surname first">
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="phone">Phone Number</label>
                                            <input v-model="volunteerForm.phone" type="number" class="form-control inputtext" id="phone" placeholder="Phone numner">
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="whatsApp">Whatsapp Number</label>
                                            <input v-model="volunteerForm.whatsapp" type="number" class="form-control inputtext" id="whatsApp" placeholder="Your WhatsApp number">
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="email">Email</label>
                                            <input v-model="volunteerForm.email" type="email" class="form-control inputtext" id="email" placeholder="Email address">
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="dob">Age range</label>
                                            <div class="text-left">
                                              <div class="form-check">
                                                <input v-model="volunteerForm.dob" class="form-check-input" type="radio" name="dob" id="dob1" value="18 - 25">
                                                <label class="form-check-label" for="twp">
                                                18 - 25 years
                                                </label>
                                              </div>
                                              <div class="form-check">
                                                <input v-model="volunteerForm.dob" class="form-check-input" type="radio" name="dob" id="dob" value="25 - above">
                                                <label class="form-check-label" for="twp">
                                                 25 - above years
                                                </label>
                                              </div>
                                            </div>
                                            <!-- <input v-model="volunteerForm.dob" type="date" class="form-control inputtext" id="dob" placeholder="Select Date"> -->
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="gender">Gender</label>
                                            <select v-model="volunteerForm.gender" class="form-control inputtext" id="gender">
                                                <option value="male">Male</option>
                                                <option value="female">Female</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="sor">State of residence</label>
                                            <select @change="getCities()" v-model="volunteerForm.state_id" class="form-control inputtext" id="sor">
                                              <option value="" slected disabled></option>
                                              <option v-for="(item, index) in states" :key="index" :value="item.id">{{ item.name }}</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="lga">City <i class="fa fa-spinner fa-spin  ml-3 f-12  btn-loader" v-if="loadingcities"></i></label>
                                            <select v-model="volunteerForm.city_id" class="form-control inputtext" id="lga">
                                              <option value="" slected disabled></option>
                                              <option v-for="(item, index) in cities" :key="index" :value="item.id">{{ item.name }}</option>
                                            </select>
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="community">Community/Area</label>
                                            <input v-model="volunteerForm.community_name" type="text" class="form-control inputtext" id="community" placeholder="Community name">
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="landmark">Closest landmark</label>
                                            <input v-model="volunteerForm.landmark" type="text" class="form-control inputtext" id="landmark" placeholder="Landmark">
                                        </div>
                                    </div>
                                </div>

                                <div class="form" v-if="currentStep === 1">
                                    <div class="row">
                                        <div class="form-group col-md-6">
                                            <label for="occupation">Current Occupation or Status</label>
                                            <input v-model="volunteerForm.current_occupation_status" type="text" class="form-control inputtext" id="occupation" placeholder="Current occupation">
                                        </div>
                                        <div class="form-group col-md-6">
                                            <label for="schoolname">School/College Name (if applicable)</label>
                                            <input v-model="volunteerForm.school_name" type="text" class="form-control inputtext" id="schoolname" placeholder="Name of school graduated">
                                        </div>
                                        
                                       
                                        <div class="form-group col-md-6">
                                            <label for="gender">Highest Educational Qualification</label>
                                            <input v-model="volunteerForm.highest_education_qualification" type="text" class="form-control inputtext" id="schoolname" placeholder="Highest qualification"></input>
                                            <!-- <select class="form-control inputtext" id="gender">
                                                <option value="male">Bsc</option>
                                                <option value="female">Higer National deploma</option>
                                                <option value="OND">Ordinary diploma</option>
                                                <option value="SSCE">SSCE</option>
                                            </select> -->
                                        </div>
                                        <div class="form-group col-md-6">
                                            <!-- <label for="sor">Experience Working With Children</label> -->
                                            <label for="sor">Years of Working With Children</label>
                                            <input v-model="volunteerForm.years_experience_with_children" type="text" class="form-control inputtext" id="schoolname" placeholder="Years of working with children"></input>
                                            <!-- <select class="form-control inputtext" id="sor" v-model="volunteerForm.years_experience_with_children">
                                                <option value="yes">Yes</option>
                                                <option value="no">NO</option>
                                            </select> -->
                                        </div>
                                    </div>
                                    <div class="form-group">
                                      <textarea v-model="volunteerForm.explanation_experience_with_children" name="description" id="" class="col-md-12 form-control" rows="3" placeholder="Describe your experience here...">
                                      </textarea>
                                    </div>
                                </div>

                                <div class="form" v-if="currentStep === 2">
                                  <div class="form-group text-left col-md-8">
                                    <label for="cry">Are you part of any community, religious, or youth group?</label>
                                    <div class="radio-options">
                                      <div class="form-check">
                                        <input class="form-check-input" type="radio" name="cry" id="cry" value="yes" v-model="volunteerForm.part_of_a_religious_or_community_group">
                                        <label class="form-check-label" for="cry">
                                        YES
                                        </label>
                                      </div>
                                      <div class="form-check">
                                        <input class="form-check-input" v-model="volunteerForm.part_of_a_religious_or_community_group" type="radio" name="cry" id="cry" value="no">
                                        <label class="form-check-label" for="cry">
                                          NO
                                        </label>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="form-group col-md-8">
                                    <label for="crycheck">If yes please provide details</label>
                                    <textarea v-model="volunteerForm.explanation_part_of_a_religious_or_community_group" name="crycheck" id="crycheck" class="col-md-12 form-control" rows="3" placeholder="Type details here..."></textarea>
                                  </div>

                                  <div class="form-group text-left col-md-8 mt-5">
                                    <label for="fam">How many families with children do you engage with?</label>
                                    <div class="radio-options">
                                      <div class="form-check">
                                        <input class="form-check-input" v-model="volunteerForm.number_of_families_with_engagement" type="radio" name="fam" id="fam" value="5-10">
                                        <label class="form-check-label" for="fam">
                                        5 - 10
                                        </label>
                                      </div>
                                      <div class="form-check">
                                        <input class="form-check-input" v-model="volunteerForm.number_of_families_with_engagement" type="radio" name="fam" id="fam" value="10-15">
                                        <label class="form-check-label" for="fam">
                                          10 - 15
                                        </label>
                                      </div>
                                      <div class="form-check">
                                        <input class="form-check-input" v-model="volunteerForm.number_of_families_with_engagement" type="radio" name="fam" id="fam" value="15-20">
                                        <label class="form-check-label" for="fam">
                                          15 - 20
                                        </label>
                                      </div>
                                      <div class="form-check">
                                        <input class="form-check-input" v-model="volunteerForm.number_of_families_with_engagement" type="radio" name="fam" id="fam" value="20-25">
                                        <label class="form-check-label" for="fam">
                                          20 - 25
                                        </label>
                                      </div>
                                      <div class="form-check">
                                        <input class="form-check-input" v-model="volunteerForm.number_of_families_with_engagement" type="radio" name="fam" id="fam" value="25-30">
                                        <label class="form-check-label" for="fam">
                                          25 - 30
                                        </label>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="form-group text-left col-md-8">
                                    <label for="social">Are you active on social media?</label>
                                    <div class="radio-options">
                                      <div class="form-check">
                                        <input class="form-check-input" v-model="volunteerForm.active_on_social_media" type="radio" name="social" id="social" value="yes">
                                        <label class="form-check-label" for="social">
                                        YES
                                        </label>
                                      </div>
                                      <div class="form-check">
                                        <input v-model="volunteerForm.active_on_social_media" class="form-check-input" type="radio" name="social" id="social" value="no">
                                        <label class="form-check-label" for="social">
                                          NO
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="form" v-if="currentStep === 3">
                                  <div class="row">
                                    <div class="form-group col-md-10">
                                      <label for="hpw">How many hours per week will you be available?</label>
                                      <input v-model="volunteerForm.hours_per_week_availability" type="text" class="form-control inputtext" id="hpw" placeholder="Hours available per week">
                                    </div>
                                      
                                    <div class="form-group text-left col-md-10">
                                      <label for="twp">Are you ready to commit to the full program?</label>
                                      <div class="radio-options">
                                        <div class="form-check">
                                          <input v-model="volunteerForm.ready_for_program" class="form-check-input" type="radio" name="twp" id="twp" value="yes">
                                          <label class="form-check-label" for="twp">
                                          YES
                                          </label>
                                        </div>
                                        <div class="form-check">
                                          <input v-model="volunteerForm.ready_for_program" class="form-check-input" type="radio" name="twp" id="twp" value="no">
                                          <label class="form-check-label" for="twp">
                                            NO
                                          </label>
                                        </div>
                                        <div class="form-check">
                                          <input v-model="volunteerForm.ready_for_program" class="form-check-input" type="radio" name="twp" id="twp" value="maybe">
                                          <label class="form-check-label" for="twp">
                                            MAYBE
                                          </label>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="form-group text-left col-md-10">
                                      <label for="internet">Do you have access to reliable internet or data for the program?</label>
                                      <div class="radio-options">
                                        <div class="form-check">
                                          <input v-model="volunteerForm.have_access_to_internet" class="form-check-input" type="radio" name="internet" id="internet" value="yes">
                                          <label class="form-check-label" for="internet">
                                          YES
                                          </label>
                                        </div>
                                        <div class="form-check">
                                          <input v-model="volunteerForm.have_access_to_internet" class="form-check-input" type="radio" name="internet" id="internet" value="no">
                                          <label class="form-check-label" for="internet">
                                            NO
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                     
                                      
                                  </div>
                                </div>

                                <div class="form" v-if="currentStep === 4">
                                  <div class="form-group">
                                    <label for="wj">Why do you want to become a Shelta SuperKids volunteer? (150–250 words)</label>
                                    <textarea v-model="volunteerForm.why_want_to_be_a_volunteer" name="wj" id="wj" maxlength="500" class="col-md-12 form-control" rows="3" placeholder="Type reasons here..."></textarea>
                                  </div>

                                  <div class="form-group">
                                    <label for="skill">Describe the specific skills or talents you will bring to the SuperKids program <span style="color: #A3A3A3;">(if selected)</span></label>
                                    <textarea v-model="volunteerForm.skill_to_bring" name="skill" id="skill" maxlength="500" class="col-md-12 form-control" rows="3" placeholder="Describe your skills here..."></textarea>
                                  </div>

                                  <div class="form-group">
                                    <label for="plans">List three ways you plan to promote Shelta SuperKids in your community <span style="color: #A3A3A3;">(if selected)</span></label>
                                    <textarea v-model="volunteerForm.three_ways_user_will_support" name="plans" id="plans" maxlength="500" class="col-md-12 form-control" rows="3" placeholder="Describe your ways here..."></textarea>
                                  </div>

                                  <div class="form-group">
                                    <label for="previous">Tell us about your previous volunteer experience  <span style="color: #A3A3A3;">(if any)</span></label>
                                    <textarea v-model="volunteerForm.previous_volunteer_experience" name="previous" id="previous" maxlength="500" class="col-md-12 form-control" rows="3" placeholder="Tell us about your experience here..."></textarea>
                                  </div>
                                </div>

                                <div class="form" v-if="currentStep === 5">
                                  <div class="form-group text-left col-md-10">
                                    <div class="radio-options">
                                      <div class="form-check">
                                        <input class="form-check-input" type="radio" name="aggrement" id="aggrement" value="yes" v-model="volunteerForm.aggreement">
                                        <label class="form-check-label" for="aggrement">
                                          By submitting this application, you agree to support SuperKids activities, participate in required training, communicate respectfully, represent the programme responsibly, consent to the use of your name and photo if selected, and confirm that your information is accurate.
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="buttonOptions container">
                                    <div class="row">
                                        <button @click="prev" v-if="currentStep != 0" class="btn col-6">Back</button>
                                        <button @click="next" v-if="currentStep != 5" :disabled="currentStep === steps.length - 1" class="btn col-6 mr-0">Next</button>
                                        <button @click="submitForm()" :disabled="volunteerForm.aggreement == ''" v-if="currentStep == 5" class="btn col-6 mr-0">Submit</button>
                                    </div>
                                </div>


                                <div
                                  class="modal center-modal fade"
                                  id="confirmSubmition"
                                  tabindex="-1"
                                  aria-labelledby="confirmPaymentBill"
                                  aria-hidden="true"
                                >
                                  <div 
                                    class="modal-dialog modal-dialog-center"
                                    style="margin-bottom: 50px;"
                                  >
                                    <div class="modal-content">
                                      <div
                                        class="modal-header pt-4 pb-2"
                                        style="margin: 0 14px; padding: inherit;"
                                      >
                                        
                                        <button
                                          @click="closeSuccess()"
                                          type="button"
                                          class="close"
                                          data-dismiss="modal"
                                          aria-label="Close"
                                        >
                                          <span aria-hidden="true">&times;</span>
                                        </button>
                                      </div>
                                      <!-- <hr /> -->
                                      <div class="modal-body modal-details">
                                        <h3>Application Submitted Successfully</h3>
                                        <h4>Thank you for applying to volunteer with Shelta SuperKids. We’ve received your application and our team will review it shortly.</h4>

                                        <div class="modal-details-sub">
                                          <h5>What happens next?</h5>
                                          <ul>
                                            <li>Application review by our team</li>
                                            <li>Shortlisted volunteers contacted within 3–5 working days</li>
                                            <li>Onboarding and orientation details shared with selected volunteers</li>
                                          </ul>
                                        </div>

                                        <p class="any-questions">If you have questions, please contact <span>volunteer@myshelta.com</span></p>
                                      </div>
                                    
                                    </div>
                                  </div>
                                </div>

                                <div v-if="loader">
                                    <PageLoader></PageLoader>
                                </div>
                            </div>  
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import PageLoader from "../components/PageLoader.vue";
import { Service } from "../store/service";
const Api = new Service();
import $ from "jquery";

export default {
  name: "SuperkidRegistration",
  components: {
    PageLoader,
  },
  data() {
    return {
      loader: false,
      loadingcities: false,
      currentStep: 0,
      currentSubStep: 0,
      aggreement: "",
      states: "",
      cities: "",
      steps: [
        "Personal Information",
        "Background and Experience",
        "Community Connections",
        "Availability and Commitment",
        "Motivation and Skills",
        "Agreement and Consent"
      ],
      substeps: [
        "Please provide your basic details so we can contact you about your application.",
        "Tell us about your background and any experience you have working with children.",
        "Tell us about your community involvement and connections with families and children.",
        "Share your availability and your commitment to completing the program.",
        "Share what inspires you to volunteer and how your skills can make an impact.",
        "Confirm your commitment to our program standards below  to continue with your application."
      ],
      stepFields: {
        0: ["fullname", "phone", "email", "dob", "gender", "state_id", "city_id", "community_name", "landmark", "gender"],        // Step 1
        1: ["current_occupation_status", "school_name", "highest_education_qualification", "years_experience_with_children", "explanation_experience_with_children"],
        2: ["part_of_a_religious_or_community_group", "number_of_families_with_engagement", "active_on_social_media"],
        3: ["hours_per_week_availability", "ready_for_program", "have_access_to_internet"],
        4: ["why_want_to_be_a_volunteer", "skill_to_bring", "three_ways_user_will_support", "previous_volunteer_experience"] ,
        5: [] 
      },
      volunteerForm: {
        fullname: "",
        phone: "",
        email: "",
        dob: "",
        gender: "",
        state_id: "",
        city_id: "",
        community_name: "",
        current_occupation_status: "",
        landmark: "",
        highest_education_qualification: "",
        school_name: "",
        years_experience_with_children: "",
        explanation_experience_with_children: "",
        part_of_a_religious_or_community_group: "",
        explanation_part_of_a_religious_or_community_group: "",
        number_of_families_with_engagement: "",
        active_on_social_media: "",
        hours_per_week_availability: "",
        ready_for_program: "",
        have_access_to_internet: "",
        why_want_to_be_a_volunteer: "",
        skill_to_bring: "",
        previous_volunteer_experience: "",
        three_ways_user_will_support: "",
        aggreement: "",
      },
      skip2: false,

    };
  },
  mounted() {
    this.getStates();
    if (this.volunteerForm.fullname == "" || this.volunteerForm.email == "" || this.volunteerForm.phone == "" || this.volunteerForm.dob == "") {
      this.skip2 = true
    }
  },
  methods: {
    isCurrentStepValid() {
      const required = this.stepFields[this.currentStep] || [];

      return required.every(field => {
        const value = this.volunteerForm[field];
        return value !== null && value !== "";
      });
    },
    next() {
      // if (this.currentStep < this.steps.length - 1) {
      //   this.currentStep++;
      // }
      if (!this.isCurrentStepValid()) {
        this.$store.commit("setApiFailed", "Please fill all fields");
        return;
      }
      if (this.currentStep < this.steps.length - 1) {
        this.currentStep++;
      }
      if (this.currentSubStep < this.substeps.length - 1) {
        this.currentSubStep++;
      }
    },
    prev() {
      if (this.currentStep > 0) {
        this.currentStep--;
      }
      if (this.currentSubStep > 0) {
        this.currentSubStep--;
      }
    },
    submitForm() {
      // const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      // console.log("Valid email", emailReg.test(this.email))
      // if (emailReg.test(this.email) == false) {
      //   return this.$store.commit("setApiFailed", "Invalid Email");
      // }
      this.loader = true;
      Api.postRequest(`volunteer-sign-up`, {
        fullname: this.volunteerForm.fullname,
        phone: this.volunteerForm.phone,
        email: this.volunteerForm.email,
        dob: this.volunteerForm.dob,
        gender: this.volunteerForm.gender,
        state_id: this.volunteerForm.state_id,
        city_id: this.volunteerForm.city_id,
        community_name: this.volunteerForm.community_name,
        current_occupation_status: this.volunteerForm.current_occupation_status,
        landmark: this.volunteerForm.landmark,
        highest_education_qualification: this.volunteerForm.highest_education_qualification,
        school_name: this.volunteerForm.school_name,
        years_experience_with_children: this.volunteerForm.years_experience_with_children,
        explanation_experience_with_children:this.volunteerForm.explanation_experience_with_children,
        part_of_a_religious_or_community_group: this.volunteerForm.part_of_a_religious_or_community_group,
        explanation_part_of_a_religious_or_community_group: this.volunteerForm.explanation_part_of_a_religious_or_community_group,
        number_of_families_with_engagement: this.volunteerForm.number_of_families_with_engagement,
        active_on_social_media: this.volunteerForm.active_on_social_media,
        hours_per_week_availability: this.volunteerForm.hours_per_week_availability,
        ready_for_program: this.volunteerForm.ready_for_program,
        have_access_to_internet: this.volunteerForm.have_access_to_internet,
        why_want_to_be_a_volunteer: this.volunteerForm.why_want_to_be_a_volunteer,
        skill_to_bring: this.volunteerForm.skill_to_bring,
        previous_volunteer_experience: this.volunteerForm.previous_volunteer_experience,
        three_ways_user_will_support: this.volunteerForm.three_ways_user_will_support,
        consent: this.volunteerForm.aggreement,
      }).then((res) => {
        // console.log("Registration successfull", res);
        this.loader = false;
        if(res.data.success) {
          $("#confirmSubmition")
          .addClass("fade")
          .modal("show");
        }
        if(res.data.error) {
          return this.$store.commit("setApiFailed", res.data.error);
        }
      }).catch(err => {
        console.log(err);
        this.loader = false;
      });
    },
    closeSuccess() {
      this.volunteerForm = {};
      this.currentStep = 0;
      this.currentSubStep = 0;
    },
    async getStates() {
      // const id = this.countryId;
      try {
        await Api.getRequest(`fetchstatesbycountryid/${161}`)
          .then(res => {
            // this.$store.commit("setApiWarning", "");
            if (res.data.success) {
              this.states = res.data.states;
            } else if (res.data.error) {
              return this.$store.commit("setApiFailed", res.data.error);
            }
          })
          .catch(err => {
            console.log(err);
          });
      } finally {
        // console.log("Closed connection");
      }
    },
    getCities: async function() {
      this.loadingcities = true;
      this.cities = [];
      const id = this.volunteerForm.state_id;
      try {
        await Api.getRequest(`fetchcitiesbystateid/${id}`)
          .then(res => {
            // this.$store.commit("setApiWarning", "");
            this.loadingcities = false;
            // console.log("Cities", res)
            if (res.data.success) {
              this.cities = res.data.cities;
              return this.$store.commit("setApiSuccess", res.data.success);
            } else if (res.data.error) {
              return this.$store.commit("setApiFailed", res.data.error);
            }
          })
          .catch(err => {
            this.loadingcities = false;
            console.log(err);
          });
      } finally {
        // console.log("Closed connection");
      }
    },
  }
};
</script>



<style scoped lang="scss">

.top-header {
    margin-top: 30px;
    padding: 20px;
    h3 {
        font-family: Lato;
        font-weight: 700;
        font-size: 30px;
        line-height: 30px;
        color: #4B4B4F;
    }
    p {
        font-family: Lato;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #5D6F7C;
        text-align: center;

    }
}


.registration-holder {
  margin-top: 40px;
    h3 {
        font-family: Lato;
        font-weight: 700;
        font-size: 18px;
        line-height: 24px;
        color: #4B4B4F;
        text-align: left;
    }
    p {
        font-family: Lato;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #5D6F7C;
        text-align: left;
    }
}
label {
  display: flex;
}

label:not(.form-check-label) {
    font-family: Lato;
    font-weight: 500;
    font-size: 16px;
    color: #1C2B3A;
    display: block;
    // justify-content: left;
    // float: left;
    text-align: left;
}
.form-check-label {
  font-family: Lato;
    font-weight: 500;
    font-size: 16px;
    color: #1C2B3A;
    padding-left: 12px;
    padding-top: 4px;
}
.inputtext {
    border: 1px solid #d2d4d7;
    height: 48px;
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    box-shadow: none;
    outline: 0;
}

input[type="radio"] {
    appearance: none;
    -webkit-appearance: none;
    width: 20px;
    height: 20px;
    border: 2px solid #ccc; /* Unselected ring width */
    border-radius: 50%;
    outline: none;
    cursor: pointer;
}

input[type="radio"]:checked {
    border-width: 6px; /* "Ring" thickens when selected */
    border-color: #2EBFCA;
}
textarea {
  box-shadow: none !important;
  outline: 0;
}
.form-check {
  margin-bottom: 10px;
}

.form {
    margin-top: 30px;
}
.radio-options {
  border: 2px solid #F5F7FA;
  padding: 20px;
  border-radius: 12px;
}

.buttonOptions {
    width: 100%;
    margin-top: 30px;
    .row {
        flex-wrap: nowrap;
        justify-content: right;
    }
    // display: flex;
    button {
        font-family: Lato;
        font-weight: 600;
        font-size: 18px;
        outline: 0;
        box-shadow: none;
        // width: 50%;
    }
    button:first-child {
        // border: 1px solid #2EBFCA;
        color: #2EBFCA;
        background: #DEF6F8;
    }
    button:last-child {
        background: #2EBFCA;
        color: #ffffff;
    }
}


// Desktop stepper starts
.wizard {
//   display: flex;
  font-family: Arial, sans-serif;
}

.steps {
//   width: 250px;
  padding: 20px;
}

.step {
    position: relative;
    padding-left: 50px;
    margin-bottom: 30px;
    color: #CCD6E5;
    text-align: left;
    font-family: Lato;
    font-weight: 400;
    font-size: 16px;
    line-height: 28px;


}

.step .indicator {
  position: absolute;
  left: 0;
  top: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid #ccc;
  text-align: center;
  line-height: 24px;
  background: #f5f5f5;
  font-weight: bold;
}

.step .line {
  position: absolute;
  left: 13px;
  top: 30px;
  width: 2px;
  height: 30px;
  background: #ccc;
}

/* Completed */
.step.completed {
  color: #2ecc71;
}

.step.completed .indicator {
  background: #2ecc71;
  border-color: #2ecc71;
  color: #fff;
}

.step.completed .line {
  background: #2ecc71;
}

/* Active */
.step.active {
  color: #2EBFCA;
}

.step.active .indicator {
  border-color: #2EBFCA;
  color: #2EBFCA;
  background: #fff;
}

/* Disabled */
.step.disabled {
  color: #aaa;
}

.step.disabled .indicator {
  border-color: #ccc;
  color: #aaa;
}

/* Content */
.content {
  flex: 1;
  padding: 30px;
  background: #fafafa;
}

.actions {
  margin-top: 20px;
}

button {
  padding: 8px 14px;
  margin-right: 10px;
}

.modal-details {
  h3 {
    font-family: Lato;
    font-weight: 700;
    font-size: 24px;
    line-height: 100%;
    color: #4B4B4F;
    text-align: center;

  }
  h4 {
    font-family: Lato;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    color: #5D6F7C;
    text-align: center;

  }
}

.modal-details-sub {
  margin-top: 30px;
  background: #F7FDFD;
  border-radius: 16px;
  padding: 24px;
  text-align: left;
  h5 {
    font-family: Lato;
    font-weight: 700;
    font-size: 16px;
    line-height: 30px;
    color: #4B4B4F;
  }
  ul {
    padding-left: 15px;
  }
  li {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 28px;
    color: #4B4B4F;

  }
}
.modal-header {
  border-bottom: none;
}

.any-questions {
  font-family: Lato;
  font-weight: 400;
  font-size: 12px;
  line-height: 30px;
  color: #5D6F7C;
  text-align: center !important;
  padding: 30px 15px;
  span {
    padding-left: 5px;
    color: #2EBFCA;
  }
}

@media only screen and (max-width: 599px) {
    .top-header  {
        h3 {
            margin-top: 20px;
            font-size: 26px;
        }
    }
}

/* Standard syntax (modern browsers) */
::placeholder {
  color: #A3A3A3;
  font-size: 12px;
  opacity: 1; /* Fixes Firefox's default lower opacity */
}

/* WebKit, Blink, & Edge (Chrome, Safari, Opera, Edge) */
::-webkit-input-placeholder {
  color: #A3A3A3;
  font-size: 12px;
  opacity: 1;
}

/* Mozilla Firefox 19+ */
::-moz-placeholder {
  color: #A3A3A3;
  font-size: 12px;
  opacity: 1;
}

/* Internet Explorer 10+ (Note: IE is no longer supported by placeholder selector) */
:-ms-input-placeholder {
  color: #A3A3A3;
  font-size: 12px;
  opacity: 1;
}

/* For Chrome, Safari, Edge, and Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0; /* Removes a small margin in older Chrome versions */
}

/* For Firefox */
input[type=number] {
    -moz-appearance: textfield;
}

/* Optional: Combine into a class for specific inputs */
.no-spinners::-webkit-outer-spin-button,
.no-spinners::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

</style>